import { bff } from './client'
import { BFF_PATHS } from '../config/constants'
import type { AssetData, OmniStatusMap } from '../types'

export const getAssetData = () => bff<AssetData>(BFF_PATHS.assetData)

export const getOmniStatusMap = () => bff<OmniStatusMap>(BFF_PATHS.omniStatusMap)
